<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">内容列表</b>
  </div>
  <div id="article-wrap">
    <div class="article-detail-title"><Title :level="2">{{ article.title }}</Title></div>
    <div class="article-detail-sub-title">{{ article.subTitle }}</div>
    <div class="article-detail-time">发布时间：{{ article.createTime }}</div>
    <div class="article-detail-abstract">摘要：{{ article.articleAbstract }}</div>
    <div v-if="article.isLive==1 & article.liveCode!=null & article.liveCode!=''" id="live-wrap" v-html="article.liveCode"></div>
    <div class="article-detail-content" v-html="article.content"></div>
  </div>


  
</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      article: {},
      page: 1,
      num: 0
    }
  },
  mounted() {
    this.workBriefing()
  },
  methods: {
    workBriefing() {
      let vm = this
      let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/article/v1.0/detail',
        data: {
          id: id,
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.article = data
        }
      });
    },
    pageChange(page) {
      this.page = page
      this.workBriefing()
    }
  }
}
</script>
